import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { LoadingScreen } from '../components/LoadingScreen';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google`, { session_id: sessionId });
        applySession(data);
        // Clear the hash so it isn't reused
        window.history.replaceState(null, '', window.location.pathname);
        navigate(data.account.role === 'super_admin' ? '/super' : '/admin', { replace: true });
      } catch (e) {
        toast.error('Google sign-in failed. Please try again.');
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, applySession]);

  return (
    <LoadingScreen label="Signing you in…" />
  );
};

export default AuthCallback;
